
import { UserRole } from "@/lib/supabase";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface UserRoleSelectorProps {
  currentRole: UserRole;
  userId: string;
  onRoleChange: (userId: string, newRole: UserRole) => Promise<void>;
}

const UserRoleSelector = ({ currentRole, userId, onRoleChange }: UserRoleSelectorProps) => {
  return (
    <Select
      defaultValue={currentRole}
      onValueChange={(value: UserRole) => onRoleChange(userId, value)}
    >
      <SelectTrigger className="w-32">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="user">User</SelectItem>
        <SelectItem value="analyst">Analyst</SelectItem>
        <SelectItem value="admin">Admin</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default UserRoleSelector;
